<lib-dialog-layout>
    <ng-container title>
        <ng-container i18n="@@TPWebsiteCloneBlockDialogTitle">Clone Block</ng-container>
    </ng-container>

    <ng-container content>
        <p class="padding-bottom-16 typography-body-medium"
            i18n="@@TPWebsiteCloneBlockDialogMessage">
            Are you sure you want to clone this block?
        </p>
        <form [formGroup]="form">
            <lib-input-select [formControl]="form.controls.Page"
            nameBy="Title"
            sortBy="Title">
                <ng-container
                    label
                    i18n="@@TPWebsiteCloneBlockDialogCloneToPageLabel">
                    Clone To
                </ng-container>
                @for (page of pages; track page.ID) {
                    <lib-input-select-item [value]="page">{{ page.Title }}</lib-input-select-item>
                }
            </lib-input-select>
        </form>
    </ng-container>

    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                qaTag="clone-block-dialog-primary-action-button"
                (clicked)="PrimaryAction()">
                <ng-container
                    label
                    i18n="@@TPWebsiteCloneBlockDialogCloneBlockButton">
                    Clone Block
                </ng-container>
            </lib-button>
            <lib-button
            [role]="ButtonRole.Secondary"
                [kind]="ButtonKind.NeutralSecondary"
                qaTag="clone-block-dialog-dismiss-action-button"
                (clicked)="DismissAction()">
                <ng-container
                    label
                    i18n="@@CommonCancelButton">
                    Cancel
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
